import { Table } from "../../../components/table-components/Table";
import { TableRowHeader } from "../../../components/table-components/TableRowHeader";
import { TableCellHeaderText } from "../../../components/table-components/TableCellHeaderText";
import { TableBody } from "../../../components/table-components/TableBody";
import { Menu } from "../models/Menus";
import { MenuListTableRow } from "./MenuListTableRow";
import { PageFooter } from "../../../components/page-skeleton/PageFooter";
import { StyledText } from "../../../assets/typography/typography";
import moment from "moment";

export type MenuType = "drafts" | "published";

type Props = {
  menus: Menu[] | undefined;
};

export const MenuTable = ({ menus }: Props) => {
  return (
    <div>
      <Table>
        <thead>
          <TableRowHeader>
            <TableCellHeaderText>Menu name</TableCellHeaderText>
            <TableCellHeaderText>Country</TableCellHeaderText>
            <TableCellHeaderText>Active on</TableCellHeaderText>
            <TableCellHeaderText>Last publsihed</TableCellHeaderText>
            <th />
          </TableRowHeader>
        </thead>
        <TableBody>
          {menus
            ?.sort((a, b) => {
              const firstDate = a.publishedAt
                ? moment(a.publishedAt)
                : undefined;
              const secondDate = b.publishedAt
                ? moment(b.publishedAt)
                : undefined;

              if (!firstDate && !secondDate) {
                return 0;
              }

              if (!firstDate) {
                return 1;
              }

              if (!secondDate) {
                return -1;
              }

              if (firstDate.isBefore(secondDate)) {
                return 1;
              }

              if (firstDate.isAfter(secondDate)) {
                return -1;
              }

              return 0;
            })
            .map((menu, i) => {
              return <MenuListTableRow key={i} menu={menu} />;
            })}
        </TableBody>
      </Table>
      <PageFooter>
        <StyledText className="bodyTextRegular mb-0">
          {menus?.length} {menus?.length === 1 ? "menu" : "menus"} in total
        </StyledText>
      </PageFooter>
    </div>
  );
};
